<div class="maps">
    <form (ngSubmit)="update()" [formGroup]="courseForm">
        <div class="title">Update maps</div>

        <app-alert />

        <div class="label">Facility Id</div>
        <input autofocus class="field" formControlName="facilityId" required type="text">
        <div class="label">Map type:</div>
        <select formControlName="mapType" class="field">
            <option [value]="MapType.Google">Google</option>
            <option [value]="MapType.Bing">Bing</option>
        </select>

        <button [disabled]="!courseForm.valid || isLoading" class="button" type="submit">
            <span [hidden]="isLoading">Update</span>
            <img [hidden]="!isLoading" alt="Loading" src="../../../assets/img/spinner.svg"/>
        </button>
    </form>
</div>
